import React from 'react';
import NewLayoutApp from './app/NewLayoutApp';
import { ThemeProvider } from './app/providers/ThemeProvider';
import { QueryProvider } from './app/providers/QueryProvider';
import { PlayerProvider } from './contexts/PlayerContext';
import { CartProvider } from './contexts/CartContext';
import { AdCartProvider } from './contexts/AdCartContext';
import { ToastProvider } from './contexts/ToastContext';

/**
 * The Sonic Motion shell is now the application shell, not an experiment.
 * Keeping a build-time v1/v2 fork made production behavior depend on whether
 * one environment variable survived the deployment pipeline. It also kept a
 * second router and navbar in the bundle. One shell means every route shares
 * the same navigation, theme, player, and responsive layout contract.
 */
function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <PlayerProvider>
          <CartProvider>
            <AdCartProvider>
              <ToastProvider>
                <NewLayoutApp />
              </ToastProvider>
            </AdCartProvider>
          </CartProvider>
        </PlayerProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

export default App;
